import {AfterViewInit, Component, Input} from '@angular/core';
import {ModalConfig} from '../../../model/modal-config';
import {PageNames} from '../../../shared/page-names.enum';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {BaseActions} from '../../../shared/base-actions';
import {Emitter} from '../../../shared/utils/emitter/emitter';
import {EmitterConstants} from '../../../shared/emitter-constants';

@Component({
  selector: 'app-trial-attempts-reached-modal',
  templateUrl: './trial-attempts-reached-modal.component.html',
  styleUrls: ['./trial-attempts-reached-modal.component.less']
})
export class TrialAttemptsReachedModalComponent extends BaseActions implements AfterViewInit {

  @Input() config: ModalConfig;
  componentName = PageNames.TRIAL_ATTEMPTS_REACHED;

  constructor(private navigationService: NavigationService) {
    super();
  }

  ngAfterViewInit() {
    this.navigationService.resetNavigation();
  }

  public onBack(): void {
    Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.componentName);
  }

}
